import type { LucideIcon } from 'lucide-react';
import { cn } from '@/shared/utils/cn';

interface Props {
    icon:     LucideIcon;
    isActive: boolean;
}

export function NavIcon({ icon: Icon, isActive }: Props) {
    return (
        <Icon
            className={cn('h-4 w-4 shrink-0', isActive ? 'text-brand-navy' : 'text-ink-500')}
            strokeWidth={2}
        />
    );
}
